import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const WorkProjects = () => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');

  // 샘플 프로젝트 데이터
  const allProjects = [
    {
      id: 1,
      name: 'Project Alpha',
      description: '3D 캐릭터 애니메이션 프로젝트',
      status: 'in_progress',
      progress: 65,
      dueDate: '2026-02-15',
      team: ['김철수', '이영희', '박민수'],
      tasks: { total: 24, completed: 16 },
      createdAt: '2025-12-01'
    },
    {
      id: 2,
      name: 'Project Beta',
      description: '환경 모델링 및 라이팅 작업',
      status: 'planning',
      progress: 15,
      dueDate: '2026-03-01',
      team: ['김철수', '박민수'],
      tasks: { total: 12, completed: 2 },
      createdAt: '2025-12-15'
    },
    {
      id: 3,
      name: 'Project Gamma',
      description: '단편 애니메이션 최종 렌더링',
      status: 'review',
      progress: 90,
      dueDate: '2026-01-20',
      team: ['이영희'],
      tasks: { total: 18, completed: 16 },
      createdAt: '2025-11-20'
    },
    {
      id: 4,
      name: 'Project Delta',
      description: '리깅 및 스키닝 작업',
      status: 'completed',
      progress: 100,
      dueDate: '2025-12-31',
      team: ['김철수', '이영희'],
      tasks: { total: 15, completed: 15 },
      createdAt: '2025-10-15'
    }
  ];

  const statusLabels = {
    planning: '기획 중',
    in_progress: '진행 중',
    review: '검토 중',
    completed: '완료'
  };

  const statusColors = {
    planning: '#9CA3AF',
    in_progress: '#3B82F6',
    review: '#F59E0B',
    completed: '#10B981'
  };

  // 필터링된 프로젝트
  const filteredProjects = allProjects.filter(project => {
    const matchesFilter = filter === 'all' || project.status === filter;
    const matchesSearch = project.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                          project.description.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  return (
    <div className="max-w-[1200px] mx-auto py-8 px-6 max-md:py-6 max-md:px-4">
      <div className="flex justify-between items-start mb-8 max-md:flex-col max-md:gap-4">
        <div>
          <h1 className="text-[28px] font-bold text-[#1e293b] m-0 mb-2">{t('nav.workProjects')}</h1>
          <p className="text-[15px] text-[#64748b] m-0">{t('nav.workProjectsDesc')}</p>
        </div>
        <button className="flex items-center gap-2 py-3 px-6 bg-gradient-to-br from-[#3b82f6] to-[#2563eb] text-white border-none rounded-[10px] text-sm font-semibold cursor-pointer transition-all duration-200 hover:-translate-y-px hover:shadow-[0_4px_12px_rgba(59,130,246,0.4)] max-md:w-full max-md:justify-center">
          <span className="text-lg font-normal">+</span> 새 프로젝트
        </button>
      </div>

      {/* 필터 및 검색 */}
      <div className="flex justify-between items-center mb-6 flex-wrap gap-4 max-md:flex-col max-md:items-stretch">
        <div className="flex gap-2 flex-wrap max-md:overflow-x-auto max-md:pb-2">
          <button
            className={`py-2 px-4 border-none rounded-[20px] text-[13px] font-medium cursor-pointer transition-all duration-200 ${filter === 'all' ? 'bg-[#3b82f6] text-white' : 'bg-[#f1f5f9] text-[#64748b] hover:bg-[#e2e8f0] hover:text-[#334155]'}`}
            onClick={() => setFilter('all')}
          >
            전체 ({allProjects.length})
          </button>
          <button
            className={`py-2 px-4 border-none rounded-[20px] text-[13px] font-medium cursor-pointer transition-all duration-200 ${filter === 'planning' ? 'bg-[#3b82f6] text-white' : 'bg-[#f1f5f9] text-[#64748b] hover:bg-[#e2e8f0] hover:text-[#334155]'}`}
            onClick={() => setFilter('planning')}
          >
            기획 중
          </button>
          <button
            className={`py-2 px-4 border-none rounded-[20px] text-[13px] font-medium cursor-pointer transition-all duration-200 ${filter === 'in_progress' ? 'bg-[#3b82f6] text-white' : 'bg-[#f1f5f9] text-[#64748b] hover:bg-[#e2e8f0] hover:text-[#334155]'}`}
            onClick={() => setFilter('in_progress')}
          >
            진행 중
          </button>
          <button
            className={`py-2 px-4 border-none rounded-[20px] text-[13px] font-medium cursor-pointer transition-all duration-200 ${filter === 'review' ? 'bg-[#3b82f6] text-white' : 'bg-[#f1f5f9] text-[#64748b] hover:bg-[#e2e8f0] hover:text-[#334155]'}`}
            onClick={() => setFilter('review')}
          >
            검토 중
          </button>
          <button
            className={`py-2 px-4 border-none rounded-[20px] text-[13px] font-medium cursor-pointer transition-all duration-200 ${filter === 'completed' ? 'bg-[#3b82f6] text-white' : 'bg-[#f1f5f9] text-[#64748b] hover:bg-[#e2e8f0] hover:text-[#334155]'}`}
            onClick={() => setFilter('completed')}
          >
            완료
          </button>
        </div>

        <div className="flex items-center gap-2.5 py-2.5 px-4 bg-[#f8fafc] border border-[#e2e8f0] rounded-[10px] min-w-[280px] max-md:min-w-full">
          <span className="text-sm text-[#94a3b8]">🔍</span>
          <input
            type="text"
            placeholder="프로젝트 검색..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="border-none bg-transparent text-sm text-[#1e293b] w-full outline-none placeholder:text-[#94a3b8]"
          />
        </div>
      </div>

      {/* 프로젝트 테이블 */}
      <div className="bg-white rounded-xl shadow-[0_1px_3px_rgba(0,0,0,0.08)] border border-[#e2e8f0] overflow-hidden max-lg:overflow-x-auto">
        <table className="w-full border-collapse max-lg:min-w-[800px]">
          <thead>
            <tr>
              <th className="text-left py-4 px-5 text-xs font-semibold text-[#64748b] uppercase tracking-[0.05em] bg-[#f8fafc] border-b border-[#e2e8f0]">프로젝트</th>
              <th className="text-left py-4 px-5 text-xs font-semibold text-[#64748b] uppercase tracking-[0.05em] bg-[#f8fafc] border-b border-[#e2e8f0]">상태</th>
              <th className="text-left py-4 px-5 text-xs font-semibold text-[#64748b] uppercase tracking-[0.05em] bg-[#f8fafc] border-b border-[#e2e8f0]">진행률</th>
              <th className="text-left py-4 px-5 text-xs font-semibold text-[#64748b] uppercase tracking-[0.05em] bg-[#f8fafc] border-b border-[#e2e8f0]">팀</th>
              <th className="text-left py-4 px-5 text-xs font-semibold text-[#64748b] uppercase tracking-[0.05em] bg-[#f8fafc] border-b border-[#e2e8f0]">마감일</th>
              <th className="text-left py-4 px-5 text-xs font-semibold text-[#64748b] uppercase tracking-[0.05em] bg-[#f8fafc] border-b border-[#e2e8f0]">작업</th>
            </tr>
          </thead>
          <tbody>
            {filteredProjects.map(project => (
              <tr key={project.id} className="hover:bg-[#f8fafc] last:[&>td]:border-b-0">
                <td className="py-4 px-5 border-b border-[#f1f5f9] align-middle min-w-[250px]">
                  <div className="flex flex-col gap-1">
                    <span className="text-[15px] font-semibold text-[#1e293b]">{project.name}</span>
                    <span className="text-[13px] text-[#64748b]">{project.description}</span>
                  </div>
                </td>
                <td className="py-4 px-5 border-b border-[#f1f5f9] align-middle">
                  <span
                    className="inline-block py-1.5 px-3 rounded-[20px] text-xs font-medium text-white"
                    style={{ backgroundColor: statusColors[project.status] }}
                  >
                    {statusLabels[project.status]}
                  </span>
                </td>
                <td className="py-4 px-5 border-b border-[#f1f5f9] align-middle">
                  <div className="flex items-center gap-3 min-w-[120px]">
                    <div className="flex-1 h-1.5 bg-[#e2e8f0] rounded-sm overflow-hidden">
                      <div
                        className="h-full rounded-sm transition-[width] duration-300"
                        style={{
                          width: `${project.progress}%`,
                          backgroundColor: statusColors[project.status]
                        }}
                      />
                    </div>
                    <span className="text-[13px] font-medium text-[#334155] min-w-[40px]">{project.progress}%</span>
                  </div>
                </td>
                <td className="py-4 px-5 border-b border-[#f1f5f9] align-middle">
                  <div className="flex">
                    {project.team.slice(0, 3).map((member, idx) => (
                      <span
                        key={idx}
                        className="w-[30px] h-[30px] rounded-full bg-gradient-to-br from-[#3B82F6] to-[#8B5CF6] text-white text-xs font-semibold flex items-center justify-center border-2 border-white -ml-2 first:ml-0"
                        title={member}
                      >
                        {member.charAt(0)}
                      </span>
                    ))}
                    {project.team.length > 3 && (
                      <span className="w-[30px] h-[30px] rounded-full bg-[#94a3b8] text-white text-[10px] font-semibold flex items-center justify-center border-2 border-white -ml-2">+{project.team.length - 3}</span>
                    )}
                  </div>
                </td>
                <td className="py-4 px-5 border-b border-[#f1f5f9] align-middle text-[13px] text-[#64748b]">{project.dueDate}</td>
                <td className="py-4 px-5 border-b border-[#f1f5f9] align-middle">
                  <div className="flex gap-1">
                    <button className="w-8 h-8 border-none bg-transparent rounded-md text-sm cursor-pointer transition-colors duration-200 flex items-center justify-center hover:bg-[#f1f5f9]" title="보기">👁️</button>
                    <button className="w-8 h-8 border-none bg-transparent rounded-md text-sm cursor-pointer transition-colors duration-200 flex items-center justify-center hover:bg-[#f1f5f9]" title="수정">✏️</button>
                    <button className="w-8 h-8 border-none bg-transparent rounded-md text-sm cursor-pointer transition-colors duration-200 flex items-center justify-center hover:bg-[#f1f5f9]" title="더보기">⋮</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {filteredProjects.length === 0 && (
          <div className="py-[60px] px-5 text-center">
            <span className="text-[48px] block mb-4">📁</span>
            <p className="text-[15px] text-[#64748b] m-0">검색 결과가 없습니다.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default WorkProjects;
